import Class from './c-content-text-lines';
import './c-content-text-lines@.vue';

export default Class;